module.exports = __webpack_public_path__ + "img/anli-3.725372bd.png";